// Import modules
import { Component, OnInit, HostListener } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { ToastrService } from '../../services/toastr.service';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { VersionService } from '../../services/version.service';
import { LOCALE_ID, Inject } from '@angular/core';
import { PrimeNGConfig } from 'primeng/api';

/**
 * Login component
 */
@Component({
  selector: 'mapfre-auditlib-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss']
})
export class LoginFormComponent implements OnInit {

  // Form login
  // form: UntypedFormGroup;

  // Domain
  domainList: any;

  // Version tooltip
  versionTooltip: any;

  // Readonly domain
  readonly: boolean = false;

  /**
   * Component constructor
   * @param authService 
   * @param router 
   * @param toasterService 
   * @param translateService 
   * @param versionService 
   */
  constructor(private authService: AuthService,
    @Inject("environment") private environment: any,
    private router: Router,
    private toasterService: ToastrService,
    private translateService: TranslateService,
    private versionService: VersionService,
    private primeNGConfig: PrimeNGConfig) {


    // Get default domain from local storage
    // let defaultDomain = localStorage.getItem("defaultDomain") ? JSON.parse(localStorage.getItem("defaultDomain")) : null;

    // Create login form
    // this.form = new UntypedFormGroup({
    //   domain: new UntypedFormControl(defaultDomain, [Validators.required]),
      // user: new UntypedFormControl(null, [Validators.required, Validators.maxLength(50)]),
      // password: new UntypedFormControl(null, Validators.compose([Validators.required]))
    // })

    // Get domains
    // this.authService.getDomainMap().subscribe(res => {
    //   this.domainList = res;

    //   // Map name to show to the user
    //   _.forEach(this.domainList, (domain) => {

    //     // Crate string to show
    //     domain.show = domain.label_for_login_screen

    //   })
    // })

    // Add domain to form
    // this.form.get("domain").valueChanges.subscribe(newValue => {
    //   if(newValue === undefined){//MU-068951 Estado resuelta
    //     localStorage.setItem("defaultDomain", null);
    //   }else{
    //     localStorage.setItem("defaultDomain", JSON.stringify(newValue));
    //   }
    // })

    // this.authService.initMsal()

    // // Subscribe to user change
    // this.form.get("user").valueChanges.subscribe(newValue => {

    //   // If @ is included, not use domain
    //   if (_.includes(newValue, '@')) {
    //     this.readonly = true;
    //     this.form.controls['domain'].clearValidators();
    //     this.form.controls['domain'].updateValueAndValidity();
    //   }
    //   else {
    //     this.readonly = false;
    //     this.form.controls['domain'].setValidators(Validators.compose([Validators.required, Validators.minLength(6)]));
    //   }
    // })
  }

  /** 
   * Init component
   */
  ngOnInit() {

    let localeUser = navigator && navigator.language ? navigator.language.split("-") : ["es"]
    let locale = localeUser && localeUser.length > 0 ? localeUser[0] : "en"
    // Translate app to locale (user is not logged) and locale is one of app languages
    if (locale.toLowerCase() == "es" || locale.toLowerCase() == "en" || locale.toLowerCase() == "pt" || locale.toLowerCase() == "tr" ||  locale.toLowerCase() == "pt_br") {
      this.translateService.currentLang = locale
      this.translateService.use(locale)
    }
    else {

      // Defaul locale english
      this.translateService.currentLang = "en"
      this.translateService.use("en")
    }
    this.translateService.get('primeng').subscribe(res => this.primeNGConfig.setTranslation(res));
    this.authService.initMsal()

    // if (this.authService.isLogged()) {
    //   this.router.navigate(['/pages/dashboard']);
    //   //iniciar el sessionStorage
    //   sessionStorage.setItem('session', localStorage.getItem(`token-${this.environment.web}`))
    //   sessionStorage.setItem('commentsArray', null)
    // }
  }

  /** 
   * When click on login or enter button
   */
  @HostListener('keydown.enter', ['$event'])
  onEnterClick() {
    if(this.router.url.includes('redirect') && this.authService.isLogged()){// mejora audiweb-enlaces
      let str = this.router.url;
      let splitted = str.split("?redirect=", 2);//identificamos redirect
      let urlRedirect = splitted[1];
      urlRedirect = urlRedirect.split('%2F').join('/');//sustituimos
      this.router.navigate([urlRedirect])//se navega
    } else{
      this.router.navigate(["/"])
    }
    // this.form.markAllAsTouched();

    // // Check form
    // if (this.form.valid) {

    //   // Get user and poassword
    //   let { domain } = this.form.value;

      // Check if user has @, not use domain
      // if (!_.includes(user, '@')) {
      //   user = `${user}@${_.get(domain, 'upn').toLowerCase()}`;
      // }

      // MFA AZURE. Deberia detenerse  antes de hacer la llamada a nuestro servicio o realizarse dentro de esta subscripción? 
      // Entiendo que antes, debido a que antes de realizar el login deberia recibir el mfa y la autorización de azure.

      this.authService.login()
      
      // Call login
      // this.authService.login(user, password).subscribe(res => {

      //   // Ok login
      //   if (res && !_.get(res, 'errorMessage')) {

      //     // Translate app to user language
      //     this.translateService.currentLang = this.authService.getLanguage()
      //     this.translateService.reloadLang(this.authService.getLanguage());

      //     //iniciar el sessionStorage
      //     // Go to dashboard
      //     this.router.navigate(["/"])
      //   }
      // }, (err) => {

      //   // Check errores
      //   if (err.status === STATUS.UNAUTHORIZED) {
      //     this.toasterService.add({ severity: 'error', summary: this.translateService.instant("TOAST.LOGIN.ERROR.AUTH"), detail: this.translateService.instant("TOAST.LOGIN.ERROR.INVALID") })
      //   }
      //   else if (err.status === STATUS.INTERNAL_SERVER_ERROR) {
      //     this.toasterService.add({ severity: 'error', summary: this.translateService.instant("TOAST.LOGIN.ERROR.AUTH"), detail: this.translateService.instant("TOAST.LOGIN.ERROR.SERVER") })
      //   }
      //   else if (err.status === STATUS.REQUEST_TIMEOUT) {
      //     this.toasterService.add({ severity: "error", summary: this.translateService.instant("TOAST.LOGIN.ERROR.AUTH"), detail: this.translateService.instant("TOAST.ERROR.TIMEOUT") });
      //   }
      //   else {
      //     this.toasterService.add({ severity: 'error', summary: this.translateService.instant("TOAST.LOGIN.ERROR.AUTH"), detail: this.translateService.instant("TOAST.LOGIN.ERROR.UNKNOWN") })
      //   }
      // })
    // }
  }

}
